/** 社群互動列單色 SVG 圖示（viewBox 0 0 24 24，currentColor；線框風格一致）。 */

function iconProps(className, { filled = false } = {}) {
  return {
    className,
    viewBox: '0 0 24 24',
    width: 20,
    height: 20,
    fill: filled ? 'currentColor' : 'none',
    stroke: 'currentColor',
    strokeWidth: filled ? 0 : 1.75,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': true,
  };
}

/** 未點讚：Heart Outline；已點讚：Filled Heart。 */
export function SocialHeartIcon({ className = '', filled = false }) {
  return (
    <svg {...iconProps(className, { filled })}>
      <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
    </svg>
  );
}

/** MessageSquare 類型留言圖示。 */
export function SocialCommentIcon({ className = '' }) {
  return (
    <svg {...iconProps(className)}>
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </svg>
  );
}

/** Repeat2 循環箭頭：轉發／引用入口（非壓縮箭頭）。 */
export function SocialRepostIcon({ className = '' }) {
  return (
    <svg {...iconProps(className)}>
      <path d="m17 2 4 4-4 4" />
      <path d="M3 11V9a4 4 0 0 1 4-4h14" />
      <path d="m7 22-4-4 4-4" />
      <path d="M21 13v2a4 4 0 0 1-4 4H3" />
    </svg>
  );
}

/** Bookmark Outline／Filled；保留下方 V 型缺口。 */
export function SocialBookmarkIcon({ className = '', filled = false }) {
  return (
    <svg {...iconProps(className, { filled })}>
      <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
    </svg>
  );
}

/** Horizontal Ellipsis：更多操作。 */
export function SocialMoreIcon({ className = '' }) {
  return (
    <svg {...iconProps(className)} fill="currentColor" stroke="none">
      <circle cx="5" cy="12" r="1.6" />
      <circle cx="12" cy="12" r="1.6" />
      <circle cx="19" cy="12" r="1.6" />
    </svg>
  );
}

/** Share: outgoing arrow; distinct from reposting to a social feed. */
export function SocialShareIcon({ className = '' }) {
  return <svg {...iconProps(className)}><path d="M12 16V3m-5 5 5-5 5 5" /><path d="M5 13v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6" /></svg>;
}
